import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DataService } from '../../services/data.service';

import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector:    'npa-utility-dialog',
    templateUrl: './npa-utility-dialog.html',
    styleUrls:  ['./npa-utility-dialog.scss'],
    providers: [
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [ MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS ]
      },
      {
        provide: MAT_DATE_FORMATS, 
        useValue: MY_FORMATS
      },
    ],
  })

  export class NpaUtilityDialog implements OnInit {
  
    constructor(
      private dataService: DataService,
      public npaUtility: MatDialogRef<NpaUtilityDialog>,
      @Inject( MAT_DIALOG_DATA ) public data: any) { }


    utilTypeObj: any;
    utilTypeOptions = [];
    filteredUtilTypeControl: FormControl = new FormControl();
    filteredUtilTypeOptions: Observable<string[]>;
    
    onNoClick(): void {
      this.npaUtility.close();
    }
    // =================================================================
    // -- 
    // =================================================================
    ngOnInit() {

      this.utilTypeObj     = {};
      this.utilTypeOptions = this.dataService.NPAUtilityTypes;

      for( var x in this.utilTypeOptions ){
        this.utilTypeObj[ this.utilTypeOptions[ x ] ] = x;
      }

      console.log("utilTypeObj",this.utilTypeObj);



      this.filteredUtilTypeOptions = this.filteredUtilTypeControl.valueChanges
      .pipe(
        startWith(''),
        map(val => this.filterUtilType(val))
      );
      
      console.log( "data in", this.data );

    }
    // =================================================================
    // -- 
    // =================================================================
    filterUtilType(val): string[] {
      
      console.log("2");
      console.log("filteredUtilTypeControl",this.filteredUtilTypeControl.value);
      console.log("utilTypeObj fil",this.utilTypeObj[ this.filteredUtilTypeControl.value ]);
      if( this.utilTypeObj[ this.filteredUtilTypeControl.value ] ){
        
        console.log("2.1");
          this.data[ "UT_TYPE" ] = parseInt(this.utilTypeObj[ this.filteredUtilTypeControl.value ]);
          console.log( "data", this.data );

      }
      console.log("2.2");
      return this.utilTypeOptions.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }
    // =================================================================
    // -- 
    // =================================================================
  
  }